/**
 * logout-cleanup.ts — Clear personalization data on logout
 */
import { devLog } from "./dev-utils.js";
import { AppState } from "./state.js";
export function clearPersonalizationData() {
    devLog("logout-cleanup", "Clearing personalization data");
    AppState.favoriteTools.clear();
    AppState.personalizationSync.clear();
    // Clear sessionStorage
    try {
        window.sessionStorage.removeItem("tn-pending-favorite");
        window.sessionStorage.removeItem("tn-pending-shortcut");
    }
    catch (error) {
        devLog("logout-cleanup", "Failed to clear sessionStorage:", error);
    }
    devLog("logout-cleanup", "Personalization data cleared");
}
// Listen for logout events
if (typeof window !== "undefined") {
    // Option 1: Listen for navigation to logout URL
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    const checkLogout = (url) => {
        if (url.includes("/auth/logout") || url.includes("/logout")) {
            clearPersonalizationData();
        }
    };
    window.history.pushState = function (...args) {
        checkLogout(args[2]?.toString() || "");
        return originalPushState.apply(this, args);
    };
    window.history.replaceState = function (...args) {
        checkLogout(args[2]?.toString() || "");
        return originalReplaceState.apply(this, args);
    };
    // Option 2: Listen for custom logout event
    window.addEventListener("tn:logout", () => {
        clearPersonalizationData();
    });
    // Option 3: Check on page load if user is no longer authenticated
    window.addEventListener("load", () => {
        const auth = window
            .__TN_AUTH__;
        const hadData = AppState.personalizationSync.hasSynced();
        const isAuthenticated = auth?.isAuthenticated === true;
        // If we had personalization data but user is no longer authenticated, clear it
        if (hadData && !isAuthenticated) {
            clearPersonalizationData();
        }
    });
}
//# sourceMappingURL=logout-cleanup.js.map